import Vue from 'vue'

export default {

  /*
   * https://gist.github.com/eikes/3925183
   */
  loadImages(imgs, callback) {
    var loaded = 0;
    var images = [];
    imgs = Object.prototype.toString.apply( imgs ) === '[object Array]' ? imgs : [imgs];
    var inc = function() {
      loaded += 1;
      if ( loaded === imgs.length && callback ) {
        callback( images );
      }
    };
    for ( var i = 0; i < imgs.length; i++ ) {
      images[i] = new Image();
      images[i].onabort = inc;
      images[i].onerror = inc;
      images[i].onload = inc;
      images[i].src = imgs[i];
    }
  },

  getStorageId() {
    const now = new Date()
    return `${now.getFullYear()}-${now.getMonth()}`
  },

  getLastStorageId() {
    return Vue.localStorage.get('lastModified')
  },

  setStorageIdNow() {
    Vue.localStorage.set('lastModified', this.getStorageId())
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils.js